import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import circleFillLogo from '../../../assets/images/circleFillLogo.png';
import '../../../css/core/components/CircleFill.scss';

const CircleFill = (props) => {
  const {
    fillHeight,
  } = props;
  const fillHeightPercentage = `${fillHeight}%`;

  return (
    <div className="circleFill-container">
      <div className="circle">
        <div className="circleFill" style={{ height: fillHeightPercentage }} />
        <img
          alt="CircleFill-logo"
          className="circleFillLogo"
          src={circleFillLogo}
        />
      </div>
    </div>
  );
};

CircleFill.propTypes = {
  fillHeight: PropTypes.number.isRequired,
};

export default (withRouter(CircleFill));
